/**
 * @param {unknown} payload
 * @returns {string}
 */
export function formatTracePayload(payload) {
  if (payload == null) return ''
  if (typeof payload === 'string') return payload
  if (typeof payload !== 'object') return String(payload)

  const lines = []
  const walk = (obj, indent = 0) => {
    const pad = '  '.repeat(indent)
    if (Array.isArray(obj)) {
      for (const item of obj) {
        if (item && typeof item === 'object' && !Array.isArray(item)) {
          lines.push(`${pad}-`)
          walk(item, indent + 1)
        } else {
          lines.push(`${pad}- ${formatScalar(item)}`)
        }
      }
      return
    }
    for (const [key, value] of Object.entries(obj)) {
      if (value != null && typeof value === 'object') {
        lines.push(`${pad}${key}:`)
        walk(value, indent + 1)
      } else {
        lines.push(`${pad}${key}: ${formatScalar(value)}`)
      }
    }
  }
  walk(payload)
  return lines.join('\n')
}

/**
 * @param {unknown} value
 */
function formatScalar(value) {
  if (value == null) return 'null'
  if (typeof value === 'string') return value
  if (typeof value === 'boolean') return value ? 'true' : 'false'
  return String(value)
}
